import { createMuiTheme } from "@material-ui/core/styles";
import { ptBR } from "@material-ui/core/locale";

export const createAppTheme = (dark = false) => {
  const paper = dark ? "#182e26" : "#ffffff";
  const tint = dark ? "#203e32" : "#e6f4ed";
  return createMuiTheme({
    palette: {
      type: dark ? "dark" : "light",
      primary: { main: dark ? "#79d9ad" : "#176b4b", contrastText: dark ? "#102a20" : "#ffffff" },
      secondary: { main: dark ? "#f4c46f" : "#a96709" },
      background: { default: dark ? "#10231c" : "#f2f7f4", paper },
      text: { primary: dark ? "#edf7f1" : "#203d31", secondary: dark ? "#b0c8bb" : "#60796c" },
      divider: dark ? "#345044" : "#dce9e1",
    },
    app: {
      gradient: "linear-gradient(135deg, #14583e 0%, #0b3024 100%)", tint,
      chat: dark ? "#10271e" : "#edf5ef",
      sent: dark ? "#245f46" : "#176b4b",
      waiting: dark ? "#493923" : "#fff2d9", waitingInk: dark ? "#f4c46f" : "#915a0c",
      blue: dark ? "#203d53" : "#e6f0fc", blueInk: dark ? "#a6cef8" : "#2d6598",
      violet: dark ? "#39314e" : "#f0eafb", violetInk: dark ? "#d0b9f3" : "#71509e",
    },
    typography: { fontFamily: 'Inter, Roboto, Arial, sans-serif', h6: { fontWeight: 650 }, button: { textTransform: "none", fontWeight: 600 } },
    shape: { borderRadius: 16 },
    scrollbarStyles: {
      "&::-webkit-scrollbar": { width: 6, height: 6 },
      "&::-webkit-scrollbar-thumb": { background: dark ? "#426b56" : "#a7c8b6", borderRadius: 8 },
    },
    overrides: {
      MuiCssBaseline: { "@global": {
        "html, body, #root": { width: "100%", minHeight: "100%", margin: 0 },
        "*": { boxSizing: "border-box" }, "img, video": { maxWidth: "100%" },
        "button:focus-visible, a:focus-visible": { outline: "3px solid #d89a30", outlineOffset: 3 },
      } },
      MuiPaper: { rounded: { borderRadius: 16 }, elevation1: { boxShadow: "0 3px 16px rgba(11,48,36,.06)" } },
      MuiButton: { root: { minHeight: 40, borderRadius: 12 }, contained: { boxShadow: "none" } },
      MuiOutlinedInput: { root: { borderRadius: 12 } },
      MuiChip: { root: { borderRadius: 9, fontWeight: 600 } },
      MuiDialog: { paper: { maxWidth: "calc(100% - 24px)", margin: 12 } },
      MuiDialogContent: { root: { padding: 16 } },
      MuiTab: { root: { textTransform: "none" } },
      MuiAvatar: { colorDefault: { color: dark ? "#b4e9ce" : "#176b4b", backgroundColor: tint } },
    },
  }, ptBR);
};
